import * as Diagram from "../../components/diagram";
import * as settings from "./setting";

/*
  @params formatSettings: 資料整理設定
  @params formatSettings => groupKey: 群組欄位 Key
  @params formatSettings => countKey: 加總欄位 Key

  @component Table
  @params isGroup: 是否有 群組分類
  @params isColSum: 是否顯示 每行總計
  @params isRowSum: 是否顯示 每列總計
  @params isPercent: 是否呈現 數量/百分比 欄位
  @params groupColumns: 群組欄位
  @params groupColumns => isGroupControl: 有子項目的欄位 是否可以控制展開(是: 顯示+/-、否: 直接展開)
  @params columns: 非群組欄位
  @params columns => isSkip: 該欄位是否 跳過計算
  @params columns => isFootSumHide: 該欄位是否 不顯示總計
  @params columns => isControl: 有子項目的欄位 是否可以控制展開(是: 顯示+/-、否: 直接展開)
  @params columns => isSum: 有子項目的欄位 是否顯示加總(小計)
  
  @component BarChart
  @params formatSettings: 資料整理設定
  @params formatSettings => groupKey: 分組欄位 Key
  @params formatSettings => countKey: 加總目標欄位 Key
  @params isVertical: 是否為橫向
  @params isBarStack: 是否為堆疊
  @params isBarFull: Y 柱狀圖 是否為滿版
  @params xKey: X 軸顯示的欄位 key
  @params isYMulti: Y 軸是否為多組(兩側)
  @params barUnit: 柱狀單位
  @params barColumns: 柱狀欄位 
  @params lineUnit: 曲線單位
  @params lineColumns: 曲線欄位
  @params exportColumns: 匯出欄位
  
  @component PieChart
  @params filter: 資料篩選設定
  @params columns: 圓餅欄位
  @params exportColumns: 匯出欄位
*/
export const option_diagram = [
  // {
  //   label: "健康關懷分析",
  //   key: "HealthCareAnalysis",
  //   path: "HealthCareAnalysis",
  //   child: [settings.HealthCareAnalysis.HealthCareServiceCenterStatus],
  // },
  // {
  //   label: "績效分析",
  //   key: "PerformanceAnalysis",
  //   path: "PerformanceAnalysis",
  //   child: [
  //     settings.PerformanceAnalysis.TargetValueAnalysis,
  //     settings.PerformanceAnalysis.RegionalPerformanceAnalysis,
  //     settings.PerformanceAnalysis.PerformanceReport,
  //     settings.PerformanceAnalysis.FirstVisitServiceVolume,
  //     settings.PerformanceAnalysis.RepeatVisitServiceVolume,
  //     settings.PerformanceAnalysis.VisitAnalysis,
  //     settings.PerformanceAnalysis.DiabetesComplianceChanges,
  //   ],
  // },
  {
    label: "肝炎追蹤",
    key: "HepatitisTracking",
    path: "HepatitisTracking",
    systemWeb: ["HEALTHCARE_CHIAYI"],
    child: [
      settings.HepatitisTracking.HepatitisTrackingToCaseStatus,
      settings.HepatitisTracking.CheckAreaToHepatitisB,
      settings.HepatitisTracking.CheckAreaToHepatitisC,
      settings.HepatitisTracking.CareVillageToHepatitis,
      settings.HepatitisTracking.CaseVisitDetail,
    ],
  },
  {
    label: "心房顫動",
    key: "AtriumFibrillation",
    path: "AtriumFibrillation",
    systemWeb: ["HEALTHCARE_CHIAYI"],
    child: [
      settings.AtriumFibrillation.CaseStatus,
      settings.AtriumFibrillation.CheckArea,
      settings.AtriumFibrillation.CareVillageToDoctorReport,
      settings.AtriumFibrillation.CaseVisitDetail,
      settings.AtriumFibrillation.DoctorDecide,
    ],
  },
  {
    label: "眼底異常",
    key: "FundusAbnormal",
    path: "FundusAbnormal",
    systemWeb: ["HEALTHCARE_CHIAYI"],
    child: [
      settings.FundusAbnormal.CaseStatusToEyeDisease,
      settings.FundusAbnormal.CheckAreaToEyeDisease,
      settings.FundusAbnormal.CareHealthCenterToEyeDisease,
      settings.FundusAbnormal.CaseStatusToExplainResult,
      settings.FundusAbnormal.CheckAreaToExplainResult,
      settings.FundusAbnormal.CareHealthCenterToExplainResult,
      settings.FundusAbnormal.UnreferredList,
      settings.FundusAbnormal.FundusChecklist,
      settings.FundusAbnormal.NoDoctorList,
    ],
  },
  {
    label: "骨肌共照",
    key: "BoneMuscleCare",
    path: "BoneMuscleCare",
    systemWeb: ["HEALTHCARE_CHIAYI_BONE"],
    child: [
      settings.BoneMuscleCare.HighRiskFactorStatistics,
      settings.BoneMuscleCare.DXALevel,
      settings.BoneMuscleCare.AILevel,
      settings.BoneMuscleCare.HealthCenterToHighRiskFactor,
      settings.BoneMuscleCare.VillageToHighRiskFactor,
      settings.BoneMuscleCare.AreaToHighRiskFactor,
      settings.BoneMuscleCare.VillageToCaseStatus,
      settings.BoneMuscleCare.VillageToDeal,
      settings.BoneMuscleCare.VillageSecondCaseClosed,
      settings.BoneMuscleCare.VillageCaseRegularRecordCompletionRate,
      settings.BoneMuscleCare.MedicationEligibleForHealthInsurance,
      settings.BoneMuscleCare.ReferralIsComplete,
      settings.BoneMuscleCare.ReferralHospital,
      settings.BoneMuscleCare.EstablishCaseVisitList,
      settings.BoneMuscleCare.ReferralList,
      settings.BoneMuscleCare.VillageHealthInsuranceReferralsCompletionRate,
      settings.BoneMuscleCare.EstablishCaseList,
    ],
  },
  {
    label: "服務申請",
    key: "ServiceApplication",
    path: "ServiceApplication",
    systemWeb: ["HEALTHCARE_CHIAYI_PSY"],
    child: [
      settings.ServiceApplication.BasicDataStatisticalAnalysis,
      settings.ServiceApplication.ServiceVolumeStatisticalAnalysis,
      settings.ServiceApplication.ClosedCaseStatisticalAnalysis,
      settings.ServiceApplication.ClosedCaseServiceEffectivenessAnalysis,
      settings.ServiceApplication.AcceptCaseStatistic,
      settings.ServiceApplication.AnnualApplicationStatistic,
    ],
  },
  {
    label: "心理諮商",
    key: "PsychologicalCounseling",
    path: "PsychologicalCounseling",
    systemWeb: ["HEALTHCARE_CHIAYI_PSY"],
    child: [
      settings.PsychologicalCounseling.CaseInformationInventory,
      settings.PsychologicalCounseling.VisitServiceVolumeStatistic,
      settings.PsychologicalCounseling.ClosedCaseStatisticalAnalysis,
      settings.PsychologicalCounseling.ClosedCaseServiceEffectivenessAnalysis,
      settings.PsychologicalCounseling.CaseStatusList,
      settings.PsychologicalCounseling.ClosedCaseList,
    ],
  },
  {
    label: "志工關懷",
    key: "VolunteerCare",
    path: "VolunteerCare",
    systemWeb: ["HEALTHCARE_CHIAYI_PSY"],
    child: [
      settings.VolunteerCare.CaseInformation,
      settings.VolunteerCare.VisitServiceVolumeStatistic,
      settings.VolunteerCare.ClosedCaseStatisticalAnalysis,
      settings.VolunteerCare.ClosedCaseServiceEffectivenessAnalysis,
      settings.VolunteerCare.CaseStatusList,
      settings.VolunteerCare.ClosedCaseList,
    ],
  },
  {
    label: "糖尿病",
    key: "Diabetes",
    path: "Diabetes",
    systemWeb: ["HEALTHCARE_YUNLIN"],
    child: [
      settings.Diabetes.DiseaseStatistic,
      settings.Diabetes.AdultHealthCheckDetail,
      settings.Diabetes.EachProjectAnalysis,
      settings.Diabetes.ThreeHighDiseaseAnalysis,
      settings.Diabetes.Hyperlipidemia,
      settings.Diabetes.Hypertension,
      settings.Diabetes.HighBloodSugar,
      settings.Diabetes.HealthCenterYearAndMonthClosedCount,
      settings.Diabetes.QuestionnaireYearAndMonthClosedCount,
    ],
  },
  {
    label: "BMI",
    key: "BMI",
    path: "BMI",
    systemWeb: ["HEALTHCARE_YUNLIN"],
    child: [
      settings.BMI.SexToBMI,
      settings.BMI.AgeToBMI,
      settings.BMI.EducationLevelToBMI,
      settings.BMI.VillageToBMI,
      settings.BMI.WorkQualityToBMI,
      settings.BMI.ExerciseHabitsTimesToBMI,
      settings.BMI.ExerciseHabitsMinutesToBMI,
      settings.BMI.ExerciseHabitsSweatPantToBMI,
      settings.BMI.CaseStatusToBMI,
      settings.BMI.EducationLevelToExercise,
      settings.BMI.WorkQualityToExercise,
      settings.BMI.NutritionManagement,
      settings.BMI.SexToNutrition,
      settings.BMI.VillageToNutrition,
      settings.BMI.EducationLevelToNutrition,
      settings.BMI.WorkQualityToNutrition,
      settings.BMI.WeightWaistManagement,
      settings.BMI.SexToWeightWaistManagement,
      settings.BMI.VillageToWeightWaistManagement,
      settings.BMI.EducationLevelToWeightWaistManagement,
      settings.BMI.WorkQualityToWeightWaistManagement,
    ],
  },
  {
    label: "衛生所健檢統計報表",
    key: "HealthCenterHealthCheckup",
    path: "HealthCenterHealthCheckup",
    systemWeb: ["HEALTHCARE_YUNLIN"],
    child: [
      settings.HealthCenterHealthCheckup.HealthCenterHealthCheckupAnalysisSex,
      // settings.HealthCenterHealthCheckup.ClosedCaseManagementSexRatio,
      // settings.HealthCenterHealthCheckup.IsSeekMedicalOnTimeSexRatio,
      // settings.HealthCenterHealthCheckup.FollowDoctorMedicationSexRatio,
      settings.HealthCenterHealthCheckup.HealthCenterHealthCheckupAnalysisAge,
      // settings.HealthCenterHealthCheckup.ClosedCaseManagementAgeRatio,
      // settings.HealthCenterHealthCheckup.IsSeekMedicalOnTimeAgeRatio,
      // settings.HealthCenterHealthCheckup.FollowDoctorMedicationAgeRatio,
      settings.HealthCenterHealthCheckup.HealthCenterYearAndMonthClosedCount,
      settings.HealthCenterHealthCheckup.QuestionnaireYearAndMonthClosedCount,
      settings.HealthCenterHealthCheckup.DiseaseStatistic,
      settings.HealthCenterHealthCheckup.AdultHealthCheckDetail,
      settings.HealthCenterHealthCheckup.HealthCheckupItemAnalysis,
      settings.HealthCenterHealthCheckup.DiseaseAnalysis,
      settings.HealthCenterHealthCheckup.ThreeHighDiseaseAnalysis,
      settings.HealthCenterHealthCheckup.Hyperlipidemia,
      settings.HealthCenterHealthCheckup.Hypertension,
      settings.HealthCenterHealthCheckup.HighBloodSugar,
    ],
  },
  {
    label: "長者健檢",
    key: "ElderlyHealthCheckup",
    path: "ElderlyHealthCheckup",
    systemWeb: ["HEALTHCARE_YUNLIN"],
    child: [
      settings.ElderlyHealthCheckup.ElderlyHealthCheckupList,
      settings.ElderlyHealthCheckup.CheckItemAnalysis,
      settings.ElderlyHealthCheckup.AgeToCheckItemAnalysis,
      settings.ElderlyHealthCheckup.DateToCheckItemAnalysis,
      settings.ElderlyHealthCheckup.VillageToAnnualScreeningCount,
      settings.ElderlyHealthCheckup.SexToCheckItemAnalysis,
      settings.ElderlyHealthCheckup.CaseCount,
    ],
  },
  {
    label: "老人健康",
    key: "ElderlyHealth",
    path: "ElderlyHealth",
    systemWeb: ["HEALTHCARE_MATSU"],
    child: [
      settings.ElderlyHealth.AD8List,
      // settings.ElderlyHealth.AD8TotalScoreDistribute,
      settings.ElderlyHealth.CaseScaleTotalScore,
      settings.ElderlyHealth.CaseScaleTotalScoreAll,
      settings.ElderlyHealth.AD8TotalScoreToCheckYear,
      settings.ElderlyHealth.IADLTotalScoreToCheckYear,
      settings.ElderlyHealth.ADLTotalScoreToCheckYear,
      settings.ElderlyHealth.SOFTotalScoreToCheckYear,
      // settings.ElderlyHealth.ElderlyHealthStatisticsReport,
      settings.ElderlyHealth.ElderlyHealthStatisticsReport112,
      // settings.ElderlyHealth.ElderlyHealthStatisticsReport113,
      settings.ElderlyHealth.ElderlyHealthVisitMonthly,
      // settings.ElderlyHealth.ElderlyHealthVisitMonthly113,
      settings.ElderlyHealth.ChronicDiseaseTypeStatistic,
      settings.ElderlyHealth.ChronicDiseaseCountStatistic,
      settings.ElderlyHealth.WeakVisitList,
      settings.ElderlyHealth.WeakNextVisitList,
      settings.ElderlyHealth.ReferralList,
      settings.ElderlyHealth.CoupleElderlyLivingAloneList,
      settings.ElderlyHealth.ElderlyHealthCaseList,
      settings.ElderlyHealth.ElderlyHealthAssessmentList,
      settings.ElderlyHealth.ElderlyHealthVisitList,
    ],
  },
  {
    label: "健康管理",
    key: "HealthManagement",
    path: "HealthManagement",
    systemWeb: ["HEALTHCHECK"],
    child: [settings.HealthManagement.HealthManagementStatisticsReport],
  },
  // {
  //   label: "衛生所健檢",
  //   key: "HealthCenterHealthCheckup",
  //   path: "HealthCenterHealthCheckup",
  //   child: [
  //     {
  //       label: "慢性病管理明細",
  //       key: "ChronicDiseaseManagementDetail",
  //       path: "HealthCenterHealthCheckup/ChronicDiseaseManagementDetail",
  //       render: (options) => (
  //         <Diagram.HealthCenterHealthCheckup.ChronicDiseaseManagementDetail {...options} />
  //       ),
  //     },
  //     {
  //       label: "慢性病管理分析(性別)",
  //       key: "ChronicDiseaseManagementGenderAnalysis",
  //       path: "HealthCenterHealthCheckup/ChronicDiseaseManagementGenderAnalysis",
  //       render: (options) => (
  //         <Diagram.HealthCenterHealthCheckup.ChronicDiseaseManagementGenderAnalysis
  //           {...options}
  //         />
  //       ),
  //     },
  //     {
  //       label: "結案管理男女比例",
  //       key: "CaseCloseManagementGenderRatio",
  //       path: "HealthCenterHealthCheckup/CaseCloseManagementGenderRatio",
  //       render: (options) => (
  //         <Diagram.HealthCenterHealthCheckup.CaseCloseManagementGenderRatio {...options} />
  //       ),
  //     },
  //     {
  //       label: "是否按時就醫男女比例",
  //       key: "TreatmentOntimeGenderRatio",
  //       path: "HealthCenterHealthCheckup/TreatmentOntimeGenderRatio",
  //       render: (options) => (
  //         <Diagram.HealthCenterHealthCheckup.TreatmentOntimeGenderRatio {...options} />
  //       ),
  //     },
  //     {
  //       label: "能遵醫囑用藥男女比例",
  //       key: "FollowDoctorMedicationGenderRatio",
  //       path: "HealthCenterHealthCheckup/FollowDoctorMedicationGenderRatio",
  //       render: (options) => (
  //         <Diagram.HealthCenterHealthCheckup.FollowDoctorMedicationGenderRatio
  //           {...options}
  //         />
  //       ),
  //     },
  //   ],
  // },
  // {
  //   label: "績效分析",
  //   key: "PerformanceAnalysis",
  //   path: "PerformanceAnalysis",
  //   child: [
  //     {
  //       label: "電話關懷分析",
  //       key: "TargetComparisonTable",
  //       path: "performanceAnalysis/TargetComparisonTable",
  //     },
  //     {
  //       label: "地區績效分析",
  //       key: "RegionalPerformanceAnalysis",
  //       path: "performanceAnalysis/RegionalPerformanceAnalysis",
  //     },
  //     {
  //       label: "績效報表",
  //       key: "PerformanceReport",
  //       path: "performanceAnalysis/PerformanceReport",
  //     },
  //     {
  //       label: "績效報表初訪人數各項服務量",
  //       key: "PerformanceReportFirstServiceCount",
  //       path: "performanceAnalysis/PerformanceReportFirstServiceCount",
  //     },
  //     {
  //       label: "績效報表複訪人次各項服務量",
  //       key: "PerformanceReportReturnServiceCount",
  //       path: "performanceAnalysis/PerformanceReportReturnServiceCount",
  //     },
  //     {
  //       label: "電話關懷分析",
  //       key: "TelephoneCareAnalysis",
  //       path: "performanceAnalysis/TelephoneCareAnalysis",
  //     },
  //     {
  //       label: "訪視分析",
  //       key: "VisitAnalysis",
  //       path: "performanceAnalysis/VisitAnalysis",
  //     },
  //     {
  //       label: "糖尿病個案醫療成效分析",
  //       key: "DiabetesEffectivenessAnalysis",
  //       path: "performanceAnalysis/DiabetesEffectivenessAnalysis",
  //     },
  //     {
  //       label: "糖尿病遵從度前後變化狀況",
  //       key: "DiabetesComplianceChange",
  //       path: "performanceAnalysis/DiabetesComplianceChange",
  //     },
  //     {
  //       label: "冠心病高風險個案醫療成效分析",
  //       key: "CoronaryHeartDiseaseEeffectivenessAnalysis",
  //       path: "performanceAnalysis/CoronaryHeartDiseaseEeffectivenessAnalysis",
  //     },
  //     {
  //       label: "冠心病遵從度前後變化狀況",
  //       key: "CoronaryHeartDiseaseComplianceChange",
  //       path: "performanceAnalysis/CoronaryHeartDiseaseComplianceChange",
  //     },
  //     {
  //       label: "肥胖個案醫療成效分析",
  //       key: "ObesityEffectivenessAnalysis",
  //       path: "performanceAnalysis/ObesityEffectivenessAnalysis",
  //     },
  //     {
  //       label: "肥胖遵從度前後變化狀況",
  //       key: "ObesityComplianceChange",
  //       path: "performanceAnalysis/ObesityComplianceChange",
  //     },
  //     {
  //       label: "白內障遵從度前後變化狀況",
  //       key: "CataractComplianceChange",
  //       path: "performanceAnalysis/CataractComplianceChange",
  //     },
  //     {
  //       label: "退化性關節炎遵從度前後變化狀況",
  //       key: "DegenerativeArthritisComplianceChange",
  //       path: "performanceAnalysis/DegenerativeArthritisComplianceChange",
  //     },
  //     {
  //       label: "體健儀使用分析",
  //       key: "FitnessDeviceUsageAnalysis",
  //       path: "performanceAnalysis/FitnessDeviceUsageAnalysis",
  //     },
  //   ],
  // },
  // {
  //   label: "電話關懷分析",
  //   key: "TelephoneCareAnalysis",
  //   path: "TelephoneCareAnalysis",
  // },
  // {
  //   label: "訪視分析",
  //   key: "VisitAnalysis",
  //   path: "VisitAnalysis",
  // },
  // {
  //   label: "個案健管分析",
  //   key: "CaseHealthManagementAnalysis",
  //   path: "CaseHealthManagementAnalysis",
  // },
  // {
  //   label: "團體健康關懷分析",
  //   key: "GroupHealthCareAnalysis",
  //   path: "GroupHealthCareAnalysis",
  // },
  // {
  //   label: "體健儀使用分析",
  //   key: "FitnessDeviceUsageAnalysis",
  //   path: "FitnessDeviceUsageAnalysis",
  // },
  // {
  //   label: "團體關懷健康績效滿意度分析",
  //   key: "GroupHealthCarePerformanceAnalysis",
  //   path: "GroupHealthCarePerformanceAnalysis",
  // },
  // {
  //   label: "眼底鏡分析",
  //   key: "GlassesAnalysis",
  //   path: "GlassesAnalysis",
  // },

  // {
  //   label: "健康資源需求表",
  //   key: "HealthResourceNeedsList",
  //   path: "HealthResourceNeedsList",
  // },
  // {
  //   label: "滿意度調查表",
  //   key: "SatisfactionSurveyForm",
  //   path: "SatisfactionSurveyForm",
  // },
  // {
  //   label: "追蹤訪視表",
  //   key: "FollowupVisitForm",
  //   path: "FollowupVisitForm",
  // },
  // {
  //   label: "慢性病管理",
  //   key: "ChronicDiseaseManagement",
  //   path: "ChronicDiseaseManagement",
  // },
  // {
  //   label: "成人健檢",
  //   key: "AdultHealthCheckup",
  //   path: "AdultHealthCheckup",
  // },
  // {
  //   label: "MNA量表",
  //   key: "Mna",
  //   path: "Mna",
  // },
  // {
  //   label: "營養教育紀錄分析報表",
  //   key: "NutritionEducationRecordAnalysis",
  //   path: "nutritionEducationRecordAnalysis",
  // },
  // {
  //   label: "長者健檢",
  //   key: "ElderlyHealthCheckup",
  //   path: "ElderlyHealthCheckup",
  // },
  // {
  //   label: "長者健檢複檢",
  //   key: "ElderlyHealthReCheckup",
  //   path: "ElderlyHealthReCheckup",
  // },
  // {
  //   label: "BMI",
  //   key: "Bmi",
  //   path: "Bmi",
  // },
  // {
  //   label: "肝炎",
  //   key: "Hepatitis",
  //   path: "Hepatitis",
  // },
  // {
  //   label: "母嬰照護",
  //   key: "MaternalInfantCare",
  //   path: "MaternalInfantCare",
  // },
  // {
  //   label: "出院服務",
  //   key: "DischargeService",
  //   path: "DischargeService",
  // },
  // {
  //   label: "老人憂鬱",
  //   key: "ElderlyDepressed",
  //   path: "ElderlyDepressed",
  // },
  // {
  //   label: "心理諮商",
  //   key: "PsychologicalCounseling",
  //   path: "PsychologicalCounseling",
  // },
  // {
  //   label: "疑似精神",
  //   key: "SuspectedSpirit",
  //   path: "SuspectedSpirit",
  // },
  {
    label: "健檢分析管理",
    key: "HealthAnalysisManagement",
    path: "HealthAnalysisManagement",
    systemWeb: ["HEALTH_A"],
    child: [
      settings.HealthAnalysisManagement.Table,
      settings.HealthAnalysisManagement.Pie,
      settings.HealthAnalysisManagement.Bar,
      settings.HealthAnalysisManagement.TableGroup,
      settings.HealthAnalysisManagement.BarCompany,
      settings.HealthAnalysisManagement.Table34,
      settings.HealthAnalysisManagement.BarTrack,
      settings.HealthAnalysisManagement.BarConsult,
    ],
  },
];
